import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function WebScrapers() {
  return <ServiceDetailPage service={servicePageContent.webScrapers} />;
}
